<template>
  <div>
    <div :class="$vuetify.breakpoint.mdAndUp ? 'd-flex' : ''">
      <h2 class="mb-2">System configuration</h2>
      <v-spacer></v-spacer>
      <v-btn
        @click="update = !update"
        :color="update ? 'warning' : 'secondary'"
      >
        {{ update ? "Updating" : "Update" }} Configuration
      </v-btn>
    </div>

    <p class="mt-6 red--text">
      <em>Click the Update Configuration button to make changes</em>
    </p>

    <v-form
      class="my-7"
      v-model="valid"
      :readonly="!update"
      @submit.prevent="updateConfiguration"
    >
      <v-card class="pa-5 mb-7">
        <h4 class="mb-5 blue-grey--text">ARTICLE PROCESSING CHARGE</h4>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              min="0"
              step="1"
              outlined
              type="number"
              label="APC for authors outside Nigeria *"
              :rules="rules.required"
              v-model="configuration.apcInternational"
              prepend-inner-icon="mdi-currency-usd"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              min="0"
              step="1"
              outlined
              type="number"
              label="APC for authors in Nigeria *"
              :rules="rules.required"
              v-model="configuration.apcLocal"
              prepend-inner-icon="mdi-currency-ngn"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>

      <div v-if="update">
        <p class="mb-7">* mark required fields.</p>
        <v-btn type="submit" large color="primary"> Save Changes </v-btn>
      </div>
    </v-form>
  </div>
</template>


<script>
import configurationTemplate from "../../../dtos/configuration";
import { required } from "../../../tools/rules";

export default {
  data: () => ({
    configuration: configurationTemplate,
    rules: {
      required,
    },
    valid: false,
    update: false,
    updating: false,
  }),

  methods: {
    fetchConfiguration() {
      this.$axios.get("/configuration").then(({ data: configuration }) => {
        this.configuration = configuration;
      });
    },

    updateConfiguration() {
      if (!this.updating) {
        this.updating = true;

        this.$axios
          .put("/configuration", { ...this.configuration })
          .then(() => {
            this.fetchConfiguration();
            this.update = false;
          })
          .finally(() => {
            this.updating = false;
          });
      }
    },
  },

  mounted() {
    this.fetchConfiguration();
  },
};
</script>